import {
  vObject,
  vOptional,
  type vOutput,
  vPicklist,
  vString,
} from '../validation/index.ts'

export const decryptSchema = vObject({
  value: vString(),
  source: vOptional(vPicklist(['freightview', 'engine'])),
})
export type DecryptRequestDto = vOutput<typeof decryptSchema>
export interface DecryptedResponse {
  decryptedValue: string
}
